export default __webpack_public_path__ + "static/media/new-icon-assessment-fill.e90e0311.svg";